import handlers from "./handlers";
import handleNetworkError from "./NetworkErrorHandler";

export default function(error) {
  if (error.response) {
    const handler = handlers.find(h =>
      h.supports(error.response.status, error.response.data.code)
    );
    handler && handler.handle(error.response.data);
  } else {
    handleNetworkError(error);
  }
}
